import React from "react";
import logo from "../../../media/logo-black.png";
import { AmenitiesListFR } from "../SchedulePages/Canada/metadata-fr";
const TorontoMetaFR = {
  hero: {
    title: "Service quotidien sans escale vers l'aéroport Pearson de Toronto (YYZ)",
    subtitle: "Commencez et terminez votre voyage plus près de chez vous à Kitchener-Waterloo (YKF) ou Hamilton (YHM)"
  },
  header: {
    title: "Évitez la conduite – détendez-vous et voyagez avec Landline",
    subtitle: (
      <>
        <p>
          Évitez les tracas de conduire jusqu'à Toronto pour ne payer que des péages coûteux, des frais de stationnement à YYZ et l'usure de votre véhicule. Laissez Landline faire le trajet pour vous.
        </p>
        <p>
          Landline propose deux façons pratiques aux passagers d'Air Canada de réserver votre service d'autocar de correspondance, selon vos besoins de voyage.
        </p>
      </>
    )
  },
  titles: {
    locations: "Emplacements et horaires",
    amenities: "Équipements"
  },
  seo: {
    title: "Landline Airport Shuttle Non-Stop Daily Service to Toronto Pearson Airport (YYZ)",
    description: ""
  }
};
const CanadaOptionsFR = {
  title: "Choisissez la meilleure option pour votre voyage",
  options: [
    {
      title: "Réservez via Air Canada",
      logo: "https://content.landline.com/wp-content/uploads/2025/01/aircanada-logo.png",
      subtitle: "(Comme un vol avec correspondance)",
      benefits: {
        title: "Avantages :",
        list: [
          <>
            <b>Protection de l’itinéraire :</b> Votre bus et votre vol sont liés sous une seule réservation. Si votre bus est retardé, Air Canada vous replacera sur le prochain départ.
          </>,
          <>
            <b>Gagnez des points Aeroplan :</b> Cumulez des points et renforcez votre statut en voyageant à bord du car de luxe.
          </>,
          <>
            <b>Un tarif unique :</b> Payez un seul tarif pour votre vol et votre transport en bus.
          </>
        ]
      },
      bestif: {
        title: "Idéal si :",
        list: [
          "Vous souhaitez une protection complète et n’avez pas encore réservé votre vol Air Canada.",
          "Réservez votre navette et votre billet d'avion ensemble en recherchant Hamilton (YHM) ou Kitchener-Waterloo (YKF) vers votre destination finale sur aircanada.com."
        ]
      },
      button: {
        title: "Réserver avec Air Canada",
        link: "https://www.aircanada.com/"
      }
    },
    {
      title: "Réservez via Landline",
      logo: logo,
      subtitle: "(Service de navette simple et facile)",
      benefits: {
        title: "Avantages :",
        list: [
          <>
            <b>Réservation rapide et simple :</b> Réservez votre navette en quelques minutes. Modifiez et gérez facilement votre réservation via Landline sans impacter votre vol.
          </>,
          <>
            <b>Horaires flexibles :</b> Réservez un aller simple ou un aller-retour. Choisissez facilement l’heure de navette qui correspond à votre emploi du temps et à vos préférences.
          </>,
          <>
            <b>Tarifs abordables :</b> Seulement 49 $ par adulte. Les enfants de 12 ans et moins voyagent GRATUITEMENT !
          </>
        ]
      },
      bestif: {
        title: "Idéal si :",
        list: [
          "Vous avez déjà réservé votre vol Air Canada",
          "Vous avez réservé via Air Canada Vacations (ACV)",
          "Vous avez seulement besoin du service d'autocar dans un seul sens",
          "Idéal pour les réservations de dernière minute"
        ]
      },
      button: {
        title: "Réserver avec Landline",
        link: "https://ca.landline.com/"
      }
    }
  ]
};

const French = {
  meta: TorontoMetaFR,
  options: CanadaOptionsFR,
  amenities: AmenitiesListFR,
  english: false,
  french: true,
}

export { TorontoMetaFR, CanadaOptionsFR, French };